<template>
    <div class="pa-3" v-if="companyId">
        <v-row no-gutters class="mb-2 rounded-xl bg-white pa-2">
            <v-col cols="12" class="d-flex align-center">
                <v-btn-back class="ml-2" @click="back()" />
                <h2 v-if="sheet" class="pl-2">
                    Cerfa {{ sheet.name }}
                    <!-- <v-icon class="ml-2">create</v-icon> -->
                </h2>
                <!-- <v-select-filled
                    v-model="selectedView"
                    :items="viewsToDisplay"
                    outlined
                    class="mx-2"
                    dense
                    hide-details
                    style="width: 80px"
                ></v-select-filled>
                <v-spacer></v-spacer> -->
                <v-btn-toggle
                    v-model="formDisplayMode"
                    class="ml-6"
                    group
                    mandatory="force"
                    rounded
                    density="compact"
                >
                    <v-btn value="TaxFormTable" class="mx-0" :disabled="!containsCerfa">
                        Saisie
                    </v-btn>
                    <v-btn value="TaxFormPng" class="ml-2" :disabled="!containsCerfa">
                        Cerfa
                    </v-btn>
                </v-btn-toggle>
                <!-- <v-spacer v-if="companyBundleType !== 'BNC'"></v-spacer>
                <v-spacer></v-spacer>
                <v-tooltip bottom v-if="selectedView === 'bundle'">
                    <template v-slot:activator="{ on, props }">
                        <v-btn
                            class="mr-2 mt-1"
                             size="small"
                            fab
                            elevation="0"
                            v-on="on"
                            v-bind="props"
                            color="#FFF"
                            @click="openGeneralLedger()"
                        >
                            <v-icon class="pb-1">$oss-general-ledger</v-icon>
                        </v-btn>
                    </template>
                    <span>Balance / Grand-Livre</span>
                </v-tooltip>
                <div v-if="bundleDependenciesErrors && !isSent">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, props }">
                            <v-btn
                                class="mr-2 mt-1"
                                 size="small"
                                fab
                                elevation="0"
                                v-on="on"
                                v-bind="props"
                                color="#FFF"
                                @click="toggleDependenciesErrorsDialog()"
                            >
                                <v-icon color="red" class="pb-1">$oss-warning</v-icon>
                            </v-btn>
                        </template>
                        <span>Champs manquants</span>
                    </v-tooltip>
                </div>
                <v-tooltip bottom v-if="selectedView === 'bundle' && !isSent">
                    <template v-slot:activator="{ on, props }">
                        <v-btn
                            class="mr-2 mt-1"
                             size="small"
                            fab
                            elevation="0"
                            v-on="on"
                            v-bind="props"
                            color="#FFF"
                            @click="toggleChecksDialog()"
                        >
                            <v-badge color="red" :content="errorsCount">
                                <v-icon color="primary" class="pb-1">$oss-warning</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    <span>Contrôles de cohérence</span>
                </v-tooltip>
                <v-btn
                    :disabled="isSaveDisabled || (isSent && selectedView === 'bundle')"
                     size="small"

                    rounded
                    elevation="0"
                    class="mr-2"
                    color="primary"
                    @click="saveBundle()"
                >
                    Enregistrer
                </v-btn>
                <v-tooltip bottom :disabled="!sendBundleDisabled">
                    <template v-slot:activator="{ on, props }">
                        <div v-on="on" v-bind="props">
                            <v-btn
                                :disabled="sendBundleDisabled || isSent"
                                 size="small"

                                rounded
                                elevation="0"
                                class="mr-2"
                                color="primary"
                                @click="openBundleDeclarationDialog()"
                            >
                                Télédéclaration
                            </v-btn>
                        </div>
                    </template>
                    <span>Bientôt disponible</span>
                </v-tooltip>
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, props }">
                        <v-btn
                            v-bind="props"
                            v-on="on"
                            icon
                            class="d-flex align-center"
                        >
                            <v-icon>$dots_vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="instructionsDialog = true">
                            <v-list-item-title>Notice d'utilisation</v-list-item-title>
                            <template v-slot:append>
                                <v-icon  size="small">$oss-help</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item :disabled="isSent">
                            <v-list-item-title>Autoriser la modification</v-list-item-title>
                            <template v-slot:append>
                                <v-switch
                                    v-model="enableEdition"
                                    color="primary"
                                    hide-details
                                    inset
                                ></v-switch>
                            </template>
                        </v-list-item>
                        <v-list-item :disabled="isSent" @click="refreshGeneralLedger()">
                            <v-list-item-title>Recalculer la balance</v-list-item-title>
                            <template v-slot:append>
                                <v-icon :disabled="isSent"  size="small">$fa-redo-alt</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item
                            :disabled="isSent"
                            @click="
                                createRows();
                                miscellaneousOperationDialog = true;
                            "
                        >
                            <v-list-item-title>Passage d'OD</v-list-item-title>
                            <template v-slot:append>
                                <v-icon :disabled="isSent"  size="small">$oss-edit</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item @click="openPrintFormsDialog(false)">
                            <v-list-item-title>Impression</v-list-item-title>
                            <template v-slot:append>
                                <v-icon  size="small">$oss-download</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item @click="generateBookletDialog = true" :disabled="!bundleId">
                            <v-list-item-title>Plaquette</v-list-item-title>
                            <template v-slot:append>
                                <v-icon  size="small">$oss-file</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item @click="updateDeclarationStatus()">
                            <v-list-item-title>Mettre à jour le statut</v-list-item-title>
                            <template v-slot:append>
                                <v-icon  size="small">$fa-redo-alt</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item @click="duplicateBundle()">
                            <v-list-item-title>Dupliquer la liasse</v-list-item-title>
                            <template v-slot:append>
                                <v-icon  size="small">$oss-duplicate</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="duplicateBundleLoading">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                                size="28"
                                class="mx-auto"
                            ></v-progress-circular>
                        </v-list-item>
                        <EDIReport :bundleId="bundleId">
                            <template #default="{ statusOk, mtaeProof }">
                                <v-list-item :disabled="!isSent || !statusOk" @click="mtaeProof">
                                    <v-list-item-title>Impression justificatf EDI</v-list-item-title>
                                    <template v-slot:append>
                                        <v-icon  size="small">$oss-download</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </EDIReport>
                        <v-list-item v-if="isSent && isUserAuthorized" @click="downloadXMLFile()">
                            <v-list-item-title>Télécharger le fichier XML</v-list-item-title>
                            <template v-slot:append>
                                <v-icon  size="small">$oss-download</v-icon>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-menu> -->
            </v-col>
        </v-row>
        <v-row no-gutters v-if="sheet">
            <v-col
                cols="12"
                class="px-2 flex-grow-1 flex-shrink-0 document-card"
                style="max-height: calc(100vh - 140px); overflow: auto"
            >
                <TaxForm
                    ref="taxForm"
                    :cerfaNumber="null"
                    :activeTab="formDisplayMode"
                    :sheet="sheet"
                    :loaded="!!sheet"
                    :enableEdition="enableEdition"
                    :isSent="true"
                />
            </v-col>
        </v-row>
    </div>
</template>
<script lang="ts">
import { BundleFront } from "@/services/bundle/BundleFront";
import TaxForm from "./TaxForm.vue";

import { NotificationBase } from "../NotificationBase";
import { SheetManager } from "../../../../backend/src/common/taxform/SheetManager";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Provide } from "vue-facing-decorator";

@Component({
    components: {
        TaxForm,
    },
})
export class TaxFormReadOnly extends NotificationBase {
    @Prop({ default: "" }) id: string;
    @Provide("taxFormFocusFromConsistencyCheck") focusSpec = "";

    formDisplayMode: "TaxFormTable" | "TaxFormPng" = "TaxFormTable";

    get company() {
        return this.$store?.state.selected_company;
    }

    get companyId() {
        return this.company?.id || null;
    }

    get userId() {
        return this.$store?.state.user?.id || null;
    }

    get containsCerfa() {
        return true;
    }

    get enableEdition() {
        return false;
    }

    back() {
        this.$router.go(-1);
    }

    sheet: SheetManager = null;

    @Watch("id")
    async onIdChanged(value, prevValue) {
        if (this.id) {
            if (this.id !== prevValue) {
                this.sheet = await BundleFront.instanciateReadOnlyBundleSheet(
                    this.companyId,
                    this.userId,
                    this.id,
                );
            }
        } else {
            this.sheet = null;
        }
    }

    beforeMount() {
        this.onIdChanged(this.id, null);
    }
}

export default toNative(TaxFormReadOnly);
</script>
